// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2pDkA","title":"AfterImages45_title__3GVF6","images":"AfterImages45_images__23sCd"};